import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AuthService } from 'utils/auth';
import { CONFIG } from 'utils/config';

const generateServiceInstance = (
  serviceOptions: AxiosRequestConfig & {
    redirectToLogin?: boolean;
    isChatService?: boolean;
  },
) => {
  const {
    redirectToLogin = true,
    isChatService = false,
    ...options
  } = serviceOptions;
  const instance = axios.create(options);

  if (isChatService) {
    instance.interceptors.request.use((req) => {
      const chatToken = req.params.chatToken;
      req.headers!.Authorization = `Bearer ${chatToken}`;
      return req;
    });
  } else {
    instance.interceptors.request.use((req) => {
      const accessToken = AuthService.ljToken();
      if (!req.headers!.Authorization) {
        req.headers!.Authorization = `Bearer ${accessToken}`;
      }
      return req;
    });
  }

  /**
   * For 401 - Redirect to login page.
   */
  instance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const status = error.response?.status;

      // log error
      if (status === 401 && redirectToLogin) {
        AuthService.logout();
        window.location.href = `${window.location.origin}/login`;
      }

      return Promise.reject(error);
    },
  );
  return instance;
};

const apiClient = generateServiceInstance({
  baseURL: CONFIG.apiUrl,
  timeout: 10000,
});

const chatAPIClient = generateServiceInstance({
  baseURL: CONFIG.websocketUrl,
  timeout: 10000,
  isChatService: true,
});

export const api = apiClient;
export const chatApi = chatAPIClient;
export { axios };
export type { AxiosError, AxiosResponse };
